import React from 'react'
import classnames from "classnames";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { updateCrypto } from "../../actions/cryptoActions";
import { withRouter } from "react-router-dom";
// import { toast } from 'react-toastify';
import { toast, ToastContainer } from "react-toastify";
import $ from 'jquery';

import 'react-toastify/dist/ReactToastify.css';
import { baseUrl } from '../../actions/baseUrl';

class CryptoUpdateModal extends React.Component {

  constructor(props) {

    super(props);
    this.state = {
      id: this.props.currentRecord.id,
      name: this.props.currentRecord.coin_name,
      short_name: this.props.currentRecord.short_name,
      crypto:{},
      errors: {},

    };
  }

  componentWillReceiveProps(nextProps) {
  
    
    if (nextProps.currentRecord) {
      console.log("nextProps.currentRecord.is_deposit", nextProps.currentRecord)
      
      this.setState({
        id: nextProps.currentRecord.id,
        name: nextProps.currentRecord.coin_name,
        short_name: nextProps.currentRecord.short_name,
      
      })
    
    }

    if (nextProps.errors) {
      this.setState({
        errors: nextProps.errors
      });
    }
    if(nextProps.crypto){
      this.setState({
        crypto:nextProps.crypto
      })
      console.log("crypto===", nextProps)
    }
      console.log("dfshufghusadfhklsa====", nextProps)
    

  }

  handleChange = (event) => {
    let { name, value } = event.target;
    console.log("valuefdvfdv", event.target)
    this.setState({ [name]: value, emptyField: false, errMsg: "" });
  };

  onChange = e => {
    if (e.target.id === 'user-update-name') {
      this.setState({ name: e.target.value });
    }
    if (e.target.id === 'user-update-short_name') {
      this.setState({ short_name: e.target.value });
    }
  
    // if (e.target.name === 'currencyImage') {
    //   var currencyImage = e.target.files[0];

    //   var fileSize = e.target.files[0].size;
    //   if (fileSize > 1000000) {
    //     this.setState({ invalidImage: "Maximum 1 MB Image allowed.", userUploadImage: false });
    //     return false;
    //   }
    //   console.log(this.state.invalidImage);
    //   if (!currencyImage.name.match(/\.(jpg|jpeg|png|gif)$/)) {
    //     this.setState({ invalidImage: "Please select valid image jpeg,png,gif.", userUploadImage: false });
    //     return false;
    //   }

    //   this.setState({
    //     coinImage: currencyImage,
    //   });
    // }

  };

  onCryptoUpdate = e => {
    e.preventDefault();

    const config = {
      headers: {
        'content-type': 'multipart/form-data'
      }
    }
    const Data={
      name:this.state.name,
      short_name:this.state.short_name,
      id:this.state.id
    }

   this.props.updateCrypto(Data, config);
 
  };

  render() {
    console.log(this.state.is_deposit)

    const { errors } = this.state;
    return (
      <div>
        <div className="modal fade" id="update-user-modal" data-backdrop="static">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Update Currency</h4>
                <button type="button" className="close" data-dismiss="modal">&times;</button>
              </div>
              <div className="modal-body">
                <form noValidate onSubmit={this.onCryptoUpdate} id="update-user">
                  <input
                    onChange={this.onChange}
                    value={this.state.id}
                    id="user-update-id"
                    type="text"
                    className="d-none" />
                  <div className="row">
                    <div className="col-md-6">
                      <div className='form-group'>
                        <label htmlFor="name">Currency Name</label>
                        <input
                          onChange={this.onChange}
                          value={this.state.name}
                          id="user-update-name"
                          type="text"
                          error={errors.name}
                          className={classnames("form-control", {
                            invalid: errors.name
                          })} />
                        <span className="text-danger">{errors.name}</span>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className='form-group'>
                        <label htmlFor="name">Currency Short Name</label>
                        <input
                          onChange={this.onChange}
                          value={this.state.short_name}
                          id="user-update-short_name"
                          type="text"
                          error={errors.short_name}
                          className={classnames("form-control", {
                            invalid: errors.short_name
                          })} />
                        <span className="text-danger">{errors.short_name}</span>
                      </div>
                    </div>
                    {/* <div className="col-md-6">
                      <div className='form-group'>
                        <label htmlFor="chain">Currency Chain Type</label>
                        <select value={this.state.chain} name="chain" onChange={this.handleChange} className="form-control">
                          <option value="">Select</option>
                          <option value="ETH">ETH</option>
                          <option value="BSC">BSC</option>
                          <option value="TRON">TRON</option>
                        </select>
                        {/* <input
                                                onChange={this.onChange}
                                                value={this.state.chain}
                                                id="chain"
                                                name="chain"
                                                type="text"
                                                error={errors.chain}
                                                className={classnames("form-control", {
                                                    invalid: errors.chain
                                                })}/> *
                        <span className="text-danger">{errors.chain}</span>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className='form-group'>
                        <label htmlFor="url">Currency Chain Url</label>
                        <input
                          onChange={this.onChange}
                          value={this.state.url}
                          id="url"
                          name="url"
                          type="text"
                          error={errors.url}
                          className={classnames("form-control", {
                            invalid: errors.url
                          })} />
                        <span className="text-danger">{errors.url}</span>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className='form-group'>
                        <label htmlFor="name">Currency Image</label>
                        <input
                          onChange={this.onChange}
                          id="currencyImage"
                          name="currencyImage"
                          type="file"
                          error={errors.currencyImage}
                          className={classnames("form-control", {
                            invalid: errors.currencyImage
                          })} />
                        <img style={{ width: "70px" }} src={baseUrl + "/static/currencyImage/" + this.state.icon} />
                        <span className="text-danger">{errors.currencyImage}</span>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className='form-group'>
                        <label htmlFor="name">Order Sequence</label>
                        <input
                          onChange={this.onChange}
                          value={this.state.order_sequence}
                          id="user-update-order_sequence"
                          type="text"
                          error={errors.order_sequence}
                          className={classnames("form-control", {
                            invalid: errors.order_sequence
                          })} />
                        <span className="text-danger">{errors.order_sequence}</span>
                      </div>
                    </div> */}
                  </div>
                  {/* <div className="row">
                    <div className='col-md-4'>
                      <div className="col-md-12">
                        <label htmlFor="is_deposit">Deposit</label>
                      </div>
                      <div className="col-md-12">
                        <div className="form-check-inline mr-0">
                          <label className="form-check-label">

                            <input
                              checked={this.state.is_deposit == 1}
                              onChange={this.onChange}
                              value="1"
                              name="is_deposit"
                              type="radio" className="form-check-input"
                              id="user-update-is-deposit"
                            />Enabled
                          </label>
                        </div>
                        <div className="form-check-inline mr-0">
                          <label className="form-check-label">
                            <input
                              checked={this.state.is_deposit == 0}
                              onChange={this.onChange}
                              value="0"
                              name="is_deposit"
                              id="user-update-is-deposit"
                              type="radio" className="form-check-input"
                            />
                            Suspended
                          </label>
                        </div>

                      </div>
                    </div>
                    <div className='col-md-4'>
                      <div className="col-md-12">
                        <label htmlFor="is_withdrawal">Withdrawal</label>
                      </div>
                      <div className="col-md-12">
                        <div className="form-check-inline mr-0">
                          <label className="form-check-label">

                            <input
                              checked={this.state.is_withdrawal == 1}
                              onChange={this.onChange}
                              value="1"
                              name="is_withdrawal"
                              type="radio" className="form-check-input"
                              id="user-update-is_withdrawal"
                            />Enabled
                          </label>
                        </div>
                        <div className="form-check-inline mr-0">
                          <label className="form-check-label">
                            <input
                              checked={this.state.is_withdrawal == 0}
                              onChange={this.onChange}
                              value="0"
                              name="is_withdrawal"
                              id="user-update-is_withdrawal"
                              type="radio" className="form-check-input"
                            />
                            Suspended
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className='col-md-4'>
                      <div className="col-md-12">
                        <label htmlFor="is_trade">Trade</label>
                      </div>
                      <div className="col-md-12">
                        <div className="form-check-inline mr-0">
                          <label className="form-check-label">

                            <input
                              checked={this.state.is_trade == 1}
                              onChange={this.onChange}
                              value="1"
                              name="is_trade"
                              type="radio" className="form-check-input"
                              id="user-update-is_trade"
                            />Enabled
                          </label>
                        </div>
                        <div className="form-check-inline mr-0">
                          <label className="form-check-label">
                            <input
                              checked={this.state.is_trade == 0}
                              onChange={this.onChange}
                              value="0"
                              name="is_trade"
                              id="user-update-is_trade"
                              type="radio" className="form-check-input"
                            />
                            Suspended
                          </label>
                        </div>
                      </div>
                    </div>
                  <div className='col-md-4'>
                      <div className="col-md-12">
                        <label htmlFor="is_show">Is show</label>
                      </div>
                      <div className="col-md-12">
                        <div className="form-check-inline mr-0">
                          <label className="form-check-label">

                            <input
                              checked={this.state.is_show == 1}
                              onChange={this.onChange}
                              value="1"
                              name="is_show"
                              type="radio" className="form-check-input"
                              id="user-update-is_show"
                            />Enabled
                          </label>
                        </div>
                        <div className="form-check-inline mr-0">
                          <label className="form-check-label">
                            <input
                              checked={this.state.is_show == 0}
                              onChange={this.onChange}
                              value="0"
                              name="is_show"
                              id="user-update-is_show"
                              type="radio" className="form-check-input"
                            />
                            Suspended
                          </label>
                        </div>
                      </div>
                    </div>
                  </div> */}

                </form>
              </div>
              <div className="modal-footer">
                <button
                  form="update-user"
                  type="submit"
                  className="btn btn-primary">
                  Update
                </button>
              </div>
            </div>
          </div>
        </div>
        <ToastContainer/>
      </div>
    )
  }
}

CryptoUpdateModal.propTypes = {
  updateCrypto: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  // crypto: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  auth: state.auth,
  errors: state.errors,
  crypto:state.crypto
});

export default connect(
  mapStateToProps,
  { updateCrypto }
)(withRouter(CryptoUpdateModal));
